<ul class="list-group">
    <li *ngFor="let contato of contatos"
        class="list-group-item"
        [class.clickable]="canOpen"
        (click)="openClick(contato)">
        <div class="list-group-item-header">
            <small class="list-group-item-title">
                {{contato.tipo | pessoaContatoTipo}}
            </small>                        
        </div>
        <div class="list-group-item-body"
            [style.font-size]="fontSize">
            <span *ngIf="contato.nome">
                <i class="far fa-user"></i> {{contato.nome}}
            </span>
            <span class="contatos-fones">
                <span *ngIf="contato.fone">
                    <i class="fas fa-phone"></i> {{contato.fone}}
                </span>
                <span *ngIf="contato.celular">
                    <i class="fas fa-mobile-alt"></i> {{contato.celular}}
                </span>
            </span>
            <span *ngIf="contato.email">
                <i class="far fa-envelope"></i> {{contato.email}}
            </span>
        </div>                                        
    </li>
</ul>